import { useEffect, useState } from "react";
import { Generico } from "../../components/Generico";
import { useForm } from "react-hook-form";
import { useToken } from "../../components/useToken";
import { MonitoreoService } from "../../service/monitoreo/MonitoreoService";
import { InputComponent } from "../../components/InputComponent";
import { Card } from "primereact/card";
import { Toolbar } from "primereact/toolbar";
import { Dialog } from "primereact/dialog";
import { confirmDialog } from "primereact/confirmdialog";
import { Parametro } from "../../models/monitoreo/Parametro";
import { Button } from "primereact/button";

export const Parametrizacion = ({ toast, generic, permss }) => {
    const omodel = new Parametro();
    const { accionesTbl } = Generico();
    const defaultValues = generic.default(omodel.model);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues } = useForm({ defaultValues, shouldTrim: true });
    const [registers, setRegisters] = useState(null);
    const { getRol } = useToken();
    const monitoreoService = new MonitoreoService();
    const [item, setItem] = useState(null);
    const [dialogParam, setDialogParam] = useState(false);
    const [selectedEmpresa, setSelectedEmpresa] = useState(null);
    const [dialogConfigurar, setDialogConfigurar] = useState(false);
    const [lista, setLista] = useState(null);
    const [loadConfig, setLoadConfig] = useState(false);
    const { table, setLoading, setTotalRecords, lazyParams, inAutocomplete, inText } = InputComponent({ registers, omodel, generic, errors, control, permss, id: getValues('id') });

    const loadLazyData = () => {
        setLoading(true);
        let _lazyParams = lazyParams;
        delete _lazyParams.rtipo;
        if (permss == null) {
            _lazyParams.rtipo = true;
        }
        if (getRol()) {
            _lazyParams.rol = getRol();
        }
        monitoreoService.listado('monitoreo/parametro/lista', { lazyEvent: JSON.stringify(_lazyParams) }).then(res => {
            setTotalRecords(res.data.total);
            setRegisters(res.data.registros);
            setLoading(false);
        });
    }

    useEffect(() => {
        loadLazyData();
    }, [lazyParams]);

    const edit = () => {
        monitoreoService.consultar(item?.id, 'monitoreo/parametro/consulta').then(res => {
            let _detalle = res.data.detalle;
            if (_detalle['empresa'] != null) {
                _detalle['empresa'] = res.data.empresa;
                setSelectedEmpresa(res.data.empresa);
            }
            reset(generic.renewValues(_detalle, omodel.model));
            setDialogParam(true);
        });
    }

    const deleteItem = () => {
        confirmDialog({
            message: '¿Está seguro de eliminar la funcionalidad?',
            header: 'Confirmación',
            icon: 'pi pi-exclamation-triangle',
            accept: () => eliminar()
        });
    }

    const eliminar = () => {
        monitoreoService.eliminar(item?.id, 'monitoreo/parametro/eliminar').then(res => {
            loadLazyData();
            generic.funcSuccess(res, toast);
        }).catch(error => {
            generic.funcDeleteError(error, toast);
        });
    }

    const itemsMenu = () => {
        const items = [];
        if (permss?.actualizar)
            items.push({ label: 'Editar', icon: 'pi pi-pencil', command: () => { edit() } });
        if (permss?.eliminar)
            items.push({ label: 'Eliminar', icon: 'pi pi-trash', command: () => { deleteItem() } });

        return [{ label: 'Opciones', items: items }];
    }

    const openNew = () => {
        setDialogParam(true);
        reset(defaultValues);
    }

    const onSubmit = (data) => {
        if (getValues('id') == null) {
            monitoreoService.nuevo(data, 'monitoreo/parametro/nuevo').then(res => {
                setDialogParam(false);
                loadLazyData();
                generic.funcSuccess(res, toast);
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
        else {
            monitoreoService.editar(data, 'monitoreo/parametro/editar').then(res => {
                setDialogParam(false);
                loadLazyData();
                generic.funcSuccess(res, toast);
            }).catch(error => {
                generic.funcError(error, toast, setError);
            });
        }
    }

    const searchEmpresa = (event) => {
        setTimeout(() => {
            if (!event.query.trim().length) {
                setLista([...lista]);
            }
            else {
                monitoreoService.consultar(event.query.toLowerCase(), 'administracion/empresa-buscar/razon').then(data => {
                    setLista(data);
                });
            }
        });
    }

    const leftToolbarTemplate = () => {
        return (
            <div className="my-2">
                <Button label="Nuevo origen" icon="pi pi-plus" className="p-button-success mr-2" type="button" onClick={openNew} />
                {permss?.crear && <Button label="Crear parámetros" icon="pi pi-bookmark" className="p-button-success mr-2" type="button" onClick={crearParametros} />}
            </div>
        );
    }

    const crearParametros = () => {
        setLoadConfig(false);
        setDialogConfigurar(true);
        reset(defaultValues);
    }

    const onConfigure = (data) => {
        setLoadConfig(true);
        monitoreoService.nuevo(data, 'monitoreo/parametro/configurar').then(res => {
            loadLazyData();
            setDialogConfigurar(false);
            setLoadConfig(false);
            generic.funcSuccess(res, toast);
        }).catch(error => {
            setLoadConfig(true);
            generic.funcError(error, toast, setError);
        });
    }

    return (
        <>
            <Card style={{ maxWidth: '100%', margin: 'auto' }}>
                <Toolbar className="mb-4" start={leftToolbarTemplate}></Toolbar>
                {table({ action01: accionesTbl, reg: setItem, items: itemsMenu() })}
            </Card>

            <Dialog visible={dialogParam} header={getValues('id') == null ? "Nuevo" : "Editar: " + item?.nombre} modal className="p-fluid modal-ssize"
                onHide={e => setDialogParam(false)} style={{ maxWidth: '400px' }} >
                {omodel.strMsg}
                <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="formgrid grid">
                        {inText('nombre', {}, 12)}
                        {inText('valor', {}, 12)}
                        {inText('codigo', {}, 12)}
                        {inAutocomplete('empresa', selectedEmpresa, setSelectedEmpresa, lista, searchEmpresa, { lab: omodel.optionLabel, col: 12, noEsActividad: true })}
                    </div>
                    {generic.buttonsForms(setDialogParam)}
                </form>
            </Dialog>

            <Dialog visible={dialogConfigurar} header="Crear parámetros iniciales por empresa" modal className="p-fluid modal-ssize"
                onHide={e => setDialogConfigurar(false)} style={{ maxWidth: '400px' }} >
                <form onSubmit={handleSubmit(onConfigure)}>
                    <div className="formgrid grid">
                        {inAutocomplete('empresa', selectedEmpresa, setSelectedEmpresa, lista, searchEmpresa, { lab: omodel.optionLabel, col: 12, noEsActividad: true })}
                        <div className="field col">
                            <Button label="configurar" style={{ maxWidth: '120px', float: 'right' }} type="submit" icon="pi pi-check" className="p-button-warning" loading={loadConfig} title="Configurar" />
                        </div>
                    </div>
                </form>
            </Dialog>
        </>
    )
}
